import React from 'react';
import { Container } from 'react-bootstrap';
import { MisCursosList } from '../../../common/cursos';

export default function MisCursos() {
  return (
    <Container fluid className="p-4">
      <h3>Mis Cursos</h3>
      <MisCursosList />
    </Container>
  );
}
